import { idb } from "../../db/index.ts";

// Call this e.g. when switching team and any existing unread message is obsolete
const deleteUnreadMessages = async () => {
	const messages = await idb.getCopies.messages(undefined, "noCopyCache");
	for (const message of messages) {
		if (!message.read) {
			await idb.cache.messages.delete(message.mid);
		}
	}
};

export default deleteUnreadMessages;
